import React from 'react';
import { Button, Modal, Form } from "react-bootstrap";

const Dialogger = props => {

    return (
        <div id="dialogger">
            <button onClick={props.handleShow} className="button special mt-3 token-btn">
                Esses conteúdos são protegidos. <br/>
                Insira a senha ou entre em contato comigo para saber mais.
            </button>

            <Modal show={props.show} onHide={props.handleClose} className="tokenModal">
                <Modal.Header closeButton>
                    <Modal.Title>Entrada de <i>Token</i></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={e => e.preventDefault()}>
                        <Form.Group controlId="token">
                            <Form.Label className="text-uppercase">Então insira seu <i>Token</i> de acesso.</Form.Label>
                            <Form.Control type="password" onChange={props.updateTokenField} />
                        </Form.Group>
                    </Form>
                    <span>Se você ainda não tem um, entre em contato comigo :)</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" disabled={!props.loaded} type="button" onClick={props.handleValidate}>
                        Acessar
                    </Button>
                    <Button variant="secondary" type="button" onClick={props.handleClose}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default Dialogger;